module.exports = __webpack_public_path__ + "media/images/checkout/challenger/check-c2c04221a76a27ba70eb0a18405cd7c2.svg";